import { render, staticRenderFns } from "./AppMapPointPanelHeader.vue?vue&type=template&id=39b6bd06&"
import script from "./AppMapPointPanelHeader.vue?vue&type=script&lang=js&"
export * from "./AppMapPointPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppMapPointPanelHeader.vue?vue&type=style&index=0&id=39b6bd06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports